import {connect} from "react-redux";
import LevelSelect from "./../component/LevelSelect";
import {changeSelectedLevel} from "./../actions/index";
import {getVisibleLevels, getLevelsDescriptions, getSelectedLevel} from "./../reducers/index";

const mapStateToProps = state => {
    return {
        levels: getVisibleLevels(state),
        descriptions: getLevelsDescriptions(state),
        selectedLevel: getSelectedLevel(state),
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChange: levelName => {
            dispatch(changeSelectedLevel(levelName))
        },
    }
}

const LevelSelectContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(LevelSelect)

export default LevelSelectContainer
